import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-875bfb9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-block" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = { "data-cy": "heading" }
const _hoisted_4 = { "data-cy": "heading-description" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "button-row" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseWrapper = _resolveComponent("BaseWrapper")!

  return (_openBlock(), _createBlock(_component_BaseWrapper, {
    verticalCenter: true,
    logoDisplay: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "logos",
          src: "/img/teladoc-mystrength-logos.png",
          alt: _ctx.$t('logoDescription')
        }, null, 8, _hoisted_2),
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('heading.title')), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('heading.description')), 1),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            class: "btn-ghost next",
            href: _ctx.teladocLoginUrl
          }, _toDisplayString(_ctx.$t('nextBtn')), 9, _hoisted_7)
        ])
      ])
    ]),
    _: 1
  }))
}